import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskKbRequestsReportsIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-kb-requests-reports-time-scale-issue',
	path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
	query: ['oldIssueView?'],
	exact: true,
};
